export default __webpack_public_path__ + "static/media/6.b174f8c8.jpg";